// HOOKS
import { useEffect, useState } from "react";
// COMPONENTS
import DropdownButton from "../../../../buttons/dropdown.button";

const DEFAULT_CLASSNAMES = {
  container: "flex flex-col  gap-1",
  checkbox: "hover:cursor-pointer dark:accent-darkPrimary accent-lightPrimary",
  checkboxContainer:
    "shadow shadow-secondary text-secondary bg-slate-50 flex flow-row rounded px-2",
  dropDownLabel:
    "hover:cursor-pointer w-full flex self-start p-2 text-sm font-ubuntuRegular",
};

const ColumnFilter = ({
  columns = [],
  handleChange = () => {},
  classNames = DEFAULT_CLASSNAMES,
}) => {
  const [showCount, setShowCount] = useState(0);
  useEffect(() => {
    setShowCount(columns.filter((column) => column?.show).length);
  }, [columns]);

  return (
    <DropdownButton
      classNames={classNames?.dropdownButton}
      label="Columns"
      value={showCount}
    >
      <div className={classNames?.container || DEFAULT_CLASSNAMES.container}>
        {columns &&
          columns.map((column) => (
            <div
              key={column?.id}
              className={
                classNames?.checkboxContainer ||
                DEFAULT_CLASSNAMES.checkboxContainer
              }
            >
              <input
                type="checkbox"
                id={column?.id}
                name={column?.id}
                checked={column?.show}
                onChange={handleChange}
                className={classNames?.checkbox || DEFAULT_CLASSNAMES.checkbox}
              />
              <label
                className={
                  classNames?.dropDownLabel || DEFAULT_CLASSNAMES.dropDownLabel
                }
                htmlFor={column?.id}
              >
                {column?.label}
              </label>
            </div>
          ))}
      </div>
    </DropdownButton>
  );
};

export default ColumnFilter;
